import { mergeIfEmpty } from "../../../../boot/utils";
import { getEmpresaScope } from "../../../../helpers/sessionEmpresa";

export const bootProdutoCommon = ({ prev }) => {
    const { empresaId } = getEmpresaScope();

    const patch = {
        empresaId,
        ativo: true,
    };

    return mergeIfEmpty(prev, patch);
};
